// extracted by mini-css-extract-plugin
export default {"overlay":"Tooltip_overlay__P6XCf","closeBtn":"Tooltip_closeBtn__CzY13"};